// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../../img/logo.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<img id=\"navbar-brand-logo\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <span id=\"navbar-brand-name\">Apps</span> <ap-navbar-separator></ap-navbar-separator> <ap-navbar-clock displaySeconds></ap-navbar-clock>";
// Exports
export default code;